(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["collection"]) return;
  try {
    

const container = document.querySelector("#filters");
const accordions = new Accordions(container, { nested: true, open: false } );


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq"] && !window.DesignMode) return;
  try {
    

const container = document.querySelector("#FAQ")
const accordions = new Accordions(container, { nested: true, open: true } )


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["index-featured-products"]) return;
  try {
    
const container = document.querySelector("#featured-gallery");
const navBtns = container.querySelectorAll("nav li");
const imageContainer = container.querySelector("#featured-gallery-images");
const images = imageContainer.querySelectorAll("img");
const formContainer = container.querySelector("#featured-gallery-forms");
const forms = formContainer.querySelectorAll(".\\@featured-form");

const scrollTo = (i) => {
    let tl = gsap.timeline();
    let xPos = imageContainer.scrollWidth / images.length * i * -1;
    let xPosForms = formContainer.scrollWidth / forms.length * i * -1;

    tl.to(imageContainer, { x: xPos, duration: 0.4 }, 0)
      .to(formContainer, { x: xPosForms, duration: 0.4 }, 0)
      .to(navBtns, { opacity: 0.2, duration: 0 }, 0)
      .to(navBtns[i], { opacity: 1, duration: 0 }, 0); 

    navBtns.forEach(btn => {btn.classList.remove("text-glitch");});
    navBtns[i].classList.add("text-glitch");
};

navBtns.forEach(btn => {
    btn.addEventListener('click', e => {
        scrollTo(btn.dataset.to);
    });
});

const background = document.getElementById("grid-background");

gsap.to(background, {
  x: `-${background.offsetHeight / 2}px`,
    ease: "none",
    scrollTrigger: {
      trigger: container,
      start: "top bottom", 
      end: `bottom top`,
      scrub: 1
    }
}); 


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["index-footer"]) return;
  try {
    
  const section = document.getElementById("index-banner");
  const background = section.querySelector("img");

  gsap.to(background, {
    y: `-${background.offsetHeight / 2}px`,
    ease: "none",
    scrollTrigger: {
        trigger: section,
        scrub: true
      }
  }); 

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["index-leaderboard"]) return;
  try {
    
const container = document.getElementById("leaderboard");
const scores = container.querySelectorAll("li");

let aos = gsap.timeline({
    scrollTrigger: {
        trigger: container,
        start: "top bottom", 
        end: "bottom bottom", 
        scrub: true, 
        onEnter: () => {
            console.log(container);

            let tl = gsap.timeline();
            tl.to(container, { y: 0, duration: 1, ease: "power3.out" }, 0)
              .to(scores, { autoAlpha: 1, stagger: 0.1, ease: "power4.out", duration: 1 }, 0)
              .to(scores, { x: 0, stagger: 0.1, duration: 0.1 }, 0);
        }
    }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["index-offers"]) return;
  try {
    

const container = document.getElementById("offers");
const offers = container.querySelectorAll(".\\@offer");
const modules = container.querySelectorAll(".\\@module");

modules.forEach((target, i) => {
    modules[i].container = target.querySelector(".\\@container");
    modules[i].overlay = target.querySelector(".\\@overlay");
});

offers.forEach(offer => {
    offer.addEventListener("click", e => {

        let tl = gsap.timeline();
        tl.to(modules[offer.dataset.index], { autoAlpha: 1, display: 'flex', duration: 0.5 }, 0)
          .to(modules[offer.dataset.index].container, { autoAlpha: 1, y: 0, duration: 1, ease: 'power3.out' }, 0.2);
    });
});

modules.forEach(modal => {
    const closeBtn = modal.querySelector("button");

    const close = () => {
        console.log("CLOSE MODULE")

        let tl = gsap.timeline();
        tl.to(modal.container, { autoAlpha: 0, y: 64, duration: 0.2, ease: 'power2.out' }, 0)
            .to(modal, { autoAlpha: 0, duration: 0.5 }, 0);
    }

    closeBtn.addEventListener("click", e => { close(); });
    modal.addEventListener("click", e => { if(e.target === modal.overlay) { close(); } });
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["index-video"]) return;
  try {
    
  const section = document.getElementById("index-video");
  const container = section.querySelector(".\\@container");
  const background = section.querySelector(".\\@background");
  const trigger = document.body;

  gsap.to(background, {
    y: `${background.offsetHeight / 2}px`,
      ease: "none",
      scrollTrigger: {
        trigger: trigger,
        start: "50 top", 
        end: `${container.offsetHeight} top`,
        scrub: true
      }
  }); 

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-related"]) return;
  try {
    
    class ProductRecommendations extends HTMLElement {
        constructor() {
        super();

        const handleIntersection = (entries, observer) => {
            if (!entries[0].isIntersecting) return;
            observer.unobserve(this);

            fetch(this.dataset.url)
            .then(response => response.text())
            .then(text => {
                const html = document.createElement('div');
                html.innerHTML = text;
                const recommendations = html.querySelector('product-recommendations');
                if (recommendations && recommendations.innerHTML.trim().length) {
                this.innerHTML = recommendations.innerHTML;
                }
            })
            .catch(e => {
                console.error(e);
            });
        }

        new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
        }
    }

    customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

})();
